import { Controller } from "@hotwired/stimulus"
import { DebounceHelper } from "~/helpers/debounce_helper"

export default class extends Controller {
  static values = {
    url: String,
  }
  static targets = ["scheduledCount", "pendingCount", "sentCount"]

  connect() {
    const _this = this
    window.addEventListener(
      "campaign--scheduled-messages:change",
      DebounceHelper.debounce(function () {
        _this.update()
      }, 500),
    )
  }

  update() {
    fetch(this.urlValue)
      .then((response) => response.json())
      .then((response) => {
        this.scheduledCountTarget.innerText = response.scheduled_messages
        this.pendingCountTarget.innerText = response.pending_messages
        this.sentCountTarget.innerText = response.sent_in_current_daily_limit
      })
  }
}
